import { apiPath } from '../../../../config';
import { queryKeys } from '../../../../utils/queryKeys';
import { axiosInstance } from '../../AxiosInstance';

export const getAllargiesData = async () => {
  return await axiosInstance({
    method: 'GET',
    url: apiPath.getAllergies,
  });
};

export const getAllMealsData = async () => {
  return await axiosInstance.get(apiPath.rawMeals);
};

export const getMealById = async (mealId) => {
  return await axiosInstance.get(`${apiPath.rawMeals}/${mealId}`);
};

const updateCachedMealList = (cachedMealsResponse, refreshedMeal, mealIdentifier) => {
  if (!cachedMealsResponse?.data || !Array.isArray(cachedMealsResponse.data)) {
    return cachedMealsResponse;
  }

  const nextMeals = [...cachedMealsResponse.data];
  const mealIndex = nextMeals.findIndex(
    (meal) =>
      meal.id === refreshedMeal.id ||
      meal.externalId === refreshedMeal.externalId ||
      meal.id === mealIdentifier ||
      meal.externalId === mealIdentifier
  );

  if (mealIndex === -1) {
    return cachedMealsResponse;
  }

  nextMeals[mealIndex] = refreshedMeal;

  return {
    ...cachedMealsResponse,
    data: nextMeals,
  };
};

export const reloadMeal = async (queryClient, mealIdentifier) => {
  const refreshedMealResponse = await getMealById(mealIdentifier);

  if (typeof queryClient?.setQueryData === 'function') {
    queryClient.setQueryData(queryKeys.getMealData, (cachedMealsResponse) =>
      updateCachedMealList(
        cachedMealsResponse,
        refreshedMealResponse.data,
        mealIdentifier
      )
    );
  }

  return refreshedMealResponse;
};

export const createMeal = async (body) => {
  return await axiosInstance.post(apiPath.meals, {
    ...body,
  });
};

export const updateMealBox = async (data) => {
  // console.log('updateMealBox', data.externalId);
  console.dir(data);
  return await axiosInstance.patch(apiPath.meals + `/${data.externalId}`, {
    ...data,
  });
};

export const deleteMeal = async (mealId) => {
  return await axiosInstance.delete(`${apiPath.meals}/${mealId}`);
};

export const patchMealBox = async ({ externalId, isDisabled }) => {
  console.log('patchMealBox', externalId, isDisabled);
  return await axiosInstance.patch(apiPath.meals + `/${externalId}`, {
    isDisabled,
  });
};

export const patchMealAssignedTags = async ({ externalId, assignedTagIds }) => {
  return await axiosInstance.patch(apiPath.meals + `/${externalId}`, {
    assignedTagIds,
  });
};
